module.exports = __webpack_public_path__ + "img/Wosslogo1.9c093acf.png";